export const DO_SIGNUP_START = 'DO_SIGNUP_START'
export const DO_SIGNUP_SUCCESS = 'DO_SIGNUP_SUCCESS'
export const DO_SIGNUP_FAILED = 'DO_SIGNUP_FAILED'
export const DO_VERIFY_EMAIL_SUCCEED = 'DO_VERIFY_EMAIL_SUCCEED'
export const DO_LOGIN_START = 'DO_LOGIN_START'
export const DO_LOGIN_SUCCESS = 'DO_LOGIN_SUCCESS'
export const DO_LOGIN_FAILED = 'DO_LOGIN_FAILED'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const DO_LOGGED_IN_WITH_DOMAIN = 'DO_LOGGED_IN_WITH_DOMAIN'
export const DO_SET_AUTH_INFO = 'DO_SET_AUTH_INFO'
export const DO_REMOVE_AUTH_INFO = 'DO_REMOVE_AUTH_INFO'
export const UPDATE_USER_PERMISSION = 'UPDATE_USER_PERMISSION'
export const UPDATE_USER_START = 'UPDATE_USER_START'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'
export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED'
export const UPLOAD_PROFILE_START = 'UPLOAD_PROFILE_START'
export const UPLOAD_PROFILE_SUCCESS = 'UPLOAD_PROFILE_SUCCESS'
export const UPLOAD_PROFILE_FAILED = 'UPLOAD_PROFILE_FAILED'